import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import * as ui from "../app/modules/common/UI/_redux/uiRedux";
import { entitiesSlice } from '../app/modules/common/DataTable/_redux/entitiesSlice';
import {customersSlice} from "../app/modules/Admin/_redux/customers/customersSlice";
import {productsSlice} from "../app/modules/Admin/_redux/products/productsSlice";
import {remarksSlice} from "../app/modules/Admin/_redux/remarks/remarksSlice";
import {specificationsSlice} from "../app/modules/Admin/_redux/specifications/specificationsSlice";

export const rootReducer = combineReducers({
  ui: ui.reducer,
  auth: auth.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  datatable: entitiesSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
